export default __webpack_public_path__ + "static/media/leetcode.e597572d.svg";